const topSellersSliderBreakPoints = {
  2560: {
    slidesPerView: 4.5,
    spaceBetween: 16,
  },
  1200: {
    slidesPerView: 3.5,
    spaceBetween: 16,
  },
  960: {
    slidesPerView: 2.5,
    spaceBetween: 16,
  },
  720: {
    slidesPerView: 2.3,
    spaceBetween: 16,
  },
  540: {
    slidesPerView: 2,
    spaceBetween: 16,
  },
  320: {
    slidesPerView: 1.3,
    spaceBetween: 16,
  },
};

export default topSellersSliderBreakPoints;
